import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterLink } from '@angular/router'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { GenericLinkModule } from '@spartacus/storefront'
import { EbResponsiveMediaComponent } from '../responsive-media/eb-responsive-media.component'

import { EBResponsiveBannerComponent } from './eb-responsive-banner.component'

@NgModule({
  imports: [
    CommonModule,
    EbResponsiveMediaComponent,
    GenericLinkModule,
    RouterLink,
    EBResponsiveBannerComponent
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        EBResponsiveBannerComponent: {
          component: EBResponsiveBannerComponent
        }
      }
    } as CmsConfig)
  ]
})
export class EBResponsiveBannerModule {}
